<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    :label="label"
    no-data-text="Раздел не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { TopicsApi } from '@/api/resources'

import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'

export default {
  name: 'BAutocompleteTopic',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    label: {
      type: String,
      default: 'Раздел',
    },
  },
  created() {
    const api = new TopicsApi()
    this.adapter = new Adapter(api)
  },
  mounted() {
    this.$refs.autocomplete.onSearchInput()
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.getAll({ ...params, model }, ...args)
    },
  },
}
</script>
